export default {
    CODA : 'coda',
    N43 : 'n43',
    PROCESSING_FEES : 'processingFees',
    FRA : 'fra',
    UNPAID_FRA : "unpaidFra"
};


// WEBPACK FOOTER //
// ./src/enums/OperationCategoryEnum.js